export const getValueLabelFormat = (value) => {
  return `${value > 0 ? '+' : ''}${value}%`;
};

export const formatScaleValue = (value, disabled = false) => {
  if (disabled) return '0.00%';
  return `${value.toFixed(2)}%`;
};
